<template>
    <div class="liga">
        <!-- navbar -->
        <Navbar showBackButton></Navbar>

        <div class="poveznice">
            <Poveznice></Poveznice>
        </div>

        <div class="container">
            <PanelPokreni v-if="appState == 'round-in-progress'"/>
        </div>

        <transition name="fade-translate" appear>
            <Loading :loadingState="loadingState">
                    <KreirajLiguField v-on:data="onKreirajLiguFieldData" v-if="!ligaId"></KreirajLiguField>
                    <KreirajLiguLink v-on:deleted="ligaRemoved()" v-if="ligaId" :ligaId="ligaId"></KreirajLiguLink>
            </Loading>
        </transition>

  </div>
</template>

<script>
import Navbar from '../components/Navbar.vue'
import Poveznice from '../components/Poveznice.vue'
import KreirajLiguField from '../components/liga/KreirajLiguField'
import KreirajLiguLink from '../components/liga/KreirajLiguLink'
import Loading from '../components/common/Loading'
import LoadingState from '../utils/loading/LoadingState'
import PanelPokreni from '../components/PanelPokreni'

export default {
    name: 'kreirajligu',
    data () {
        return {
            ligaId: null,
            ligaName: null
        }
    },
    components: {
        Navbar,
        Poveznice,
        KreirajLiguField,
        KreirajLiguLink,
        Loading,
        PanelPokreni
    },
    mounted () {
        if (this.userVlasnikLige) {
            this.ligaId = this.userVlasnikLige
        }
    },
    methods: {
        onKreirajLiguFieldData (data) {
            if (data.success === true) {
                this.ligaId = data.ligaId
                this.ligaName = data.nazivLige
                this.sendGA(true)
            }
        },
        async ligaRemoved () {
            this.$store.commit('setUserDataVlasnikLige', undefined)
            this.ligaId = undefined
            await this.$db.metadata.fetchMetadata()
            this.sendGA(false)
        },
        sendGA (ligaCreated) {
            // eslint-disable-next-line no-undef
            gtag('event', 'click', {
                'event_category': 'Korisnička liga',
                'event_label': `${ligaCreated ? 'Kreirana liga' : 'Obrisana liga'}`
            })
        }
    },
    watch: {
        userVlasnikLige (after, before) {
            if (after) {
                this.ligaId = after
            }
        }
    },
    computed: {
        loadingState () {
            try {
                if (this.loading) {
                    return LoadingState.LOADING
                } else {
                    return LoadingState.SUCCESS
                }
            } catch (error) {
                return LoadingState.LOADING
            }
        },
        loading () {
            try {
                return !this.$store.state.metadata.loaded
            } catch (error) {
                return true
            }
        },
        userVlasnikLige () {
            try {
                return this.$store.state.metadata.userData.vlasnikLige
            } catch (error) {
                return false
            }
        },
        appState () {
            return this.$store.state.appState
        }
    }
}
</script>

<style lang="scss" scoped>
.liga {
    padding: 22px 0;

    .poveznice {
        margin-bottom: 30px;
    }

    .container {
        padding: 0 24px 24px;
    }
}

@media only screen and (min-width: 800px) {
    .liga {
        max-width: 1280px;
        margin: auto;
    }
}
</style>
